<template>
      <div no-body class="lku-dim"> 
        <b-row>
        <b-col lg="11">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.kode" @keyup.13.native="search()" placeholder="Dimension Name" style="width:30% !important;"></b-form-input>
                  <b-form-input v-model="tblData.nama" @keyup.13.native="search()" placeholder="Dimension Code" class="ml-1"></b-form-input>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
            </b-input-group>
            </b-col>
        </b-row>
      <b-table
        class="mb-0"
        ref="tblDimVal"
        responsive
        striped hover
        :items="tblData.items"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="updatetable" 
        @row-clicked="selectItem"
      >
          <template v-slot:cell(kode)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.kode" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.kode"></span>
          </template>
          <template v-slot:cell(nama)="data">
            <span v-if="(data.item.judul=='Y')" v-html="data.item.nama" style="font-weight:bold;"></span>
            <span v-else v-html="data.item.nama"></span>
          </template>
          <template v-slot:cell(aktif)="data">
            <span v-if="(data.item.aktif=='0')">NON ACTIVE</span>
          </template>

        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-dim {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import dim from "../../apis/dimensionsample";

export default {
  data() {
    return {
      fields: [
          {
            key: "kode",
            label: "Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "nama",
            label: "Name",
            sortable: true
          },
          {
            key: "aktif",
            label: "Active",
            thStyle: "width:40px",
            sortable: true
          },

      ],
      updatetable:false,
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        filter: null,
        total: 0,
        kode: "",nama: "",aktif:'1'
      }
    };
  },
  props: ["DimColName","lkudata"],
  created: async function() {
      // this.$emit('update:DimColName', 'Dim1');
      if ((this.lkudata.items) && (this.lkudata.DimColName==this.DimColName))
      {
          for (var key in this.lkudata) {
              this.tblData[key] = this.lkudata[key];
          }
      } else {
        this.data();
      }
  },  
  watch: {
    "tblData.page": function(newval) {
      this.tblData.page=newval;
      this.refresh();
    },   
    "tblData.limit": function(newval) {
      this.data();
    },   
    "tblData.sortBy": function(newval) {
      this.data();
    },   
    "tblData.sortDesc": function(newval) {
      this.data();
    },   
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.DimColName=this.DimColName || "Dim1";
      const items= await dim.list(this.tblData);      
      this.tblData.items = items;      
      this.updatetable=!this.updatetable;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
          this.tblData.selected=item;
          this.$emit("click", this.tblData);
    },
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblDimVal.refresh();
       }
    },    
    refresh() {
      this.data();
      this.$refs.tblDimVal.refresh();
    },
    search() {
      this.tblData.page=1;
      this.data();
      this.$refs.tblDimVal.refresh();
    },
    clearFilter() {
      this.tblData.kode='';
      this.tblData.nama=''
    }   

  }
};
</script>
